<label class="select-field">
  <span class="select-field__label">
    {{ label() }}
    @if (required()) {
      <span class="select-field__required">*</span>
    }
  </span>

  <div
    class="select-field__control"
    [class.select-field__control--clickable]="!!matSelect()"
    (click)="openOnBoxClick($event)"
  >
    <div class="select-field__content">
      <ng-content></ng-content>
    </div>
    <mat-icon class="select-field__icon">keyboard_arrow_down</mat-icon>
  </div>

  @if (invalid() && errorText()) {
    <span class="select-field__error">{{ errorText() }}</span>
  }
</label>
